"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingStatus = exports.TrainingType = void 0;
var TrainingType;
(function (TrainingType) {
    TrainingType["DEFAULT"] = "default";
    TrainingType["BOOST"] = "boost";
})(TrainingType || (exports.TrainingType = TrainingType = {}));
var TrainingStatus;
(function (TrainingStatus) {
    TrainingStatus["ACTIVE"] = "active";
    TrainingStatus["COMPLETED"] = "completed";
})(TrainingStatus || (exports.TrainingStatus = TrainingStatus = {}));
